import { Header, Loader } from "@egovernments/digit-ui-react-components";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { convertEpochToDateDMY } from "../../../utils";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { Button, Card } from "@mui/material";
import DialogContentModal from "../../../../../templates/ApplicationDetails/components/DialogContent";
import TakeActionItem from "../../../../../templates/Forms/TakeActionItem";
import useDepartmentSelector from "../TCPForms/hooks/useDepartmentSelector";

const EdcrApplications = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [smShowMs, setSmShowMs] = useState(false);
  const [idData, setIdData] = useState("");
  const [formType, setFormType] = useState("");
  const [data, setEdcrData] = useState([]);
  const { control, register } = useForm();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const userInfo = Digit.UserService.getUser()?.info || {};
  console.log("userInfo", userInfo?.uuid);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const applicationType = "FORM_11";
  const limit = rowsPerPage;
  const [isUdFlow, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const departement = applicationFlow;

  

   async function fetchEdcrData() {
      try {
        const response = await Digit.OBPSService.scrutinyDetails(tenantId);
        console.log(response, "scrutnizedData");
        setEdcrData(response?.edcrDetail);
      } catch (error) {
        console.error("Error fetching migrated data:", error);
      }
    }
  
    useEffect(() => {
      fetchEdcrData();
    }, []);
    console.log("dataaaaa", data);


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const [page, setPage] = React.useState(0);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#1f4a7c",
      color: theme.palette.common.white,
      fontSize: 16,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  const [orderBy, setOrderBy] = useState("applicationNo");
  const [order, setOrder] = useState("desc");
  const handleSort = (column) => {
    if (orderBy === column) {
      setOrder(order === "asc" ? "desc" : "asc");
    } else {
      setOrderBy(column);
      setOrder("asc");
    }
  };
  const sortedData = data?.PermissionOfSubdivision?.sort((a, b) => {
    if (order === "asc") {
      return a[orderBy] < b[orderBy] ? -1 : 1;
    } else {
      return b[orderBy] < a[orderBy] ? -1 : 1;
    }
  });

  const closeModal2 = (item) => {
    if (item?.applicationType === "FORM_11") {
      setIdData(item?.applicationNo);
      setFormType("form11");
      if (item?.applicationNo != null) {
        setSmShowMs(true);
      } else {
        console.log("Application Number Null 11");
      }
    } else if (item?.applicationType === "FORM_26") {
      setIdData(item?.applicationNo);
      setFormType("form26");
      if (item?.applicationNo != null) {
        setSmShowMs(true);
      } else {
        console.log("Application Number Null26 ");
      }
    } else {
      console.log("all", item);
    }
  };
  console.log("column1", data, sortedData);

  if (applicationFlow === null) {
    return <DepartmentSelector />;
  }

  return (
    <div>
      {/* {loader && <Loader />} */}

      <div style={{ margin: "10px 5%" }}>
        <Paper sx={{ overflow: "hidden", marginY: 2 }}>
          <div style={{ marginLeft: "8px", fontSize: "24px" }}>{`${t("EDCR_APPLICATIONS")}`}</div>
          <TableContainer sx={{ maxHeight: 500 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Application Number</StyledTableCell>
                  <StyledTableCell>Date</StyledTableCell>
                  <StyledTableCell>
                    Edcr Number
                    
                  </StyledTableCell>
                  <StyledTableCell>Dxf File</StyledTableCell>
                 

                  <StyledTableCell>
                    Plan Report
                  </StyledTableCell>
                  <StyledTableCell>Status </StyledTableCell>
                  <StyledTableCell>Drawing File</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.map((item, index) => {
                  return (
                    <StyledTableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                      <StyledTableCell>{item?.applicationNumber}</StyledTableCell>
                      <StyledTableCell>{convertEpochToDateDMY(item?.applicationDate)}</StyledTableCell>
                      <StyledTableCell>
                        {item?.edcrNumber}
                      </StyledTableCell>
                      <StyledTableCell component="th" scope="row">
                           <Button
                              size="small"
                              sx={{ ml: 1, fontSize: "10px", alignContent: "center", display: "flex" }}
                              variant="contained"
                              color="primary"
                              onClick={() => {
                                window.open(item?.dxfFile, "_blank");
                              }}
                            >
                              <span>View</span>
                            </Button>
                      </StyledTableCell>
                      <StyledTableCell component="th" scope="row">
                      <Button
                              size="small"
                              sx={{ ml: 1, fontSize: "10px", alignContent: "center", display: "flex" }}
                              variant="contained"
                              color="primary"
                              onClick={() => {
                                window.open(item?.planReport, "_blank");
                              }}
                            >
                              <span>View</span>
                            </Button>
                      </StyledTableCell>
                      <StyledTableCell component="th" scope="row">
                        {item?.status}
                      </StyledTableCell>
                      <StyledTableCell component="th" scope="row">
                      <Button
                              size="small"
                              sx={{ ml: 1, fontSize: "10px", alignContent: "center", display: "flex" }}
                              variant="contained"
                              color="primary"
                              onClick={() => {
                                window.open(item?.updatedDxfFile, "_blank");
                              }}
                            >
                              <span>View</span>
                            </Button>
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50, 75, 100]}
            component="div"
            count={data?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>

      <DialogContentModal
        title={"Application Details"}
        dataOpen={smShowMs}
        onClose={() => {
          setSmShowMs(false);
        }}
      >
        <TakeActionItem id={idData} formType={formType} />
      </DialogContentModal>
    </div>
  );
};
export default EdcrApplications;
